import { ACCESS_DENIED } from '@/constants/routes';
import { useUserStore } from '@/stores/user';

export default function accessToTemplates() {
  return () => {
    const access = useUserStore().companySectionsRights;

    if (access.find(item => item.name === 'docuseal')) {
      return true;
    }

    return { name: ACCESS_DENIED };
  };
}
